import {
  FETCH_DCM_CAMPAIGNS,
  SELECT_CAMPAIGN_ID
} from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";

const initialCampaignState = {
  isLoading: false,
  data: [],
  byId: {},
  selectedId: ""
};

let campaignsById = campaigns => {
  let byId = {};
  campaigns.map(campaign => {
    return (byId[campaign.id] = campaign);
  });
  return byId;
};

export const dcmCampaigns = (state = initialCampaignState, action) => {
  switch (action.type) {
    case FETCH_DCM_CAMPAIGNS:
      switch (action.status) {
        case SUCCESS:
          return {
            ...state,
            isLoading: false,
            data: [...action.data],
            byId: campaignsById(action.data)
          };
        case FAILURE:
          return {
            ...state,
            isLoading: false,
            data: [...state.data],
            byId: { ...state.byId }
          };
        case PENDING:
          return {
            ...state,
            isLoading: true,
            data: [...state.data],
            byId: { ...state.byId }
          };
        default:
          return state;
      }
    case SELECT_CAMPAIGN_ID:
      return {
        ...state,
        data: [...state.data],
        byId: { ...state.byId },
        selectedId: action.id
      };
    default:
      return state;
  }
};
